"use client";

import { m } from "motion/react";

import { useTranslation } from "@/lib/hooks/use-translation";

export function BlogHeader() {
  const { t } = useTranslation();

  return (
    <header className="mx-auto flex max-w-3xl flex-col items-center gap-10 text-center">
      <div className="flex flex-col items-center gap-1">
        {/* No fade-up on the heading. It is the page's LCP element, and
            Chrome does not count text as painted while it sits at opacity 0 —
            the same 0.6s+ the home hero lost to it (see commit 50458c0). The
            underline below still draws itself in; it is decoration, not text. */}
        <h1
          className="max-w-[680px] text-[26px] font-bold leading-[1.6] text-black min-[390px]:text-[28px] sm:text-[32px] sm:leading-[1.5] md:text-[40px] md:leading-[1.65]"
        >
          <span>
            {t("blogPage.headingPrefix")}
            <span className="relative inline-block whitespace-nowrap">
              {t("blogPage.headingHighlight")}
              <m.svg
                aria-hidden="true"
                width="153"
                height="9"
                viewBox="0 0 153 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="pointer-events-none absolute left-1/2 top-full mt-[-14px] w-[130px] -translate-x-1/2 min-[390px]:w-[140px] sm:w-[230px]"
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
              >
                <m.path
                  d="M1.90381 6.90405C26.2303 1.90405 51.0637 1.07072 76.4038 4.40405C101.744 7.73739 126.577 6.90405 150.904 1.90405"
                  stroke="#F9C31F"
                  strokeWidth="3.80732"
                  strokeLinecap="round"
                  variants={{
                    hidden: { pathLength: 0, opacity: 0 },
                    show: {
                      pathLength: 1,
                      opacity: 1,
                      transition: {
                        pathLength: {
                          duration: 0.8,
                          delay: 0.55,
                          ease: [0.16, 1, 0.3, 1],
                        },
                        opacity: { duration: 0.01, delay: 0.55 },
                      },
                    },
                  }}
                />
              </m.svg>
            </span>
            {t("blogPage.headingSuffix")}
          </span>
          <span>{t("blogPage.headingTail")}</span>
        </h1>
        <p className="max-w-2xl text-sm font-medium leading-5 text-black/60">
          {t("blogPage.subtitle")}
        </p>
      </div>
    </header>
  );
}
